module.exports = __webpack_public_path__ + "img/pattern_gold.9ffd386a.svg";